import { render, staticRenderFns } from "./gkTestD.vue?vue&type=template&id=db55def2&scoped=true&"
import script from "./gkTestD.vue?vue&type=script&lang=js&"
export * from "./gkTestD.vue?vue&type=script&lang=js&"
import style0 from "./gkTestD.vue?vue&type=style&index=0&id=db55def2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db55def2",
  null
  
)

export default component.exports